module.exports = __webpack_public_path__ + "img/icon-x2.2c887ad2.svg";